import React, { useContext, useEffect, useState } from 'react';
import { LoginContainer, LoginColumn, LoginOverlay, LoginLogo, LoginImage, LoginhighlightedText, LoginText, LoginButton, LoginCopyright, LoginCopyrightTextLine, LoginCopyrightImage } from './styles';
import { H4, H6 } from '../../components/Typography/styles';
import { KeycloakContext } from '../../store/index';
import Loader from '../../components/Loader';
import logo from '../../assets/images/logo-excelcredit.svg';
import loginImage from '../../assets/images/login-image.svg';
import copyrightImage from '../../assets/images/copyright-image.svg';
import { useHistory } from 'react-router';
import { checkExpiresToken, verifyActiveSession } from '../../services/authentication';
import colors from '../../assets/styles/colors';

const LoginPage = () => {
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const { authenticated, keycloak } = useContext(KeycloakContext);

  useEffect(() => {
    if (authenticated) {
      return verifyActiveSession(keycloak) ? history.push({
        pathname: '/admin/simulator',
        login: true
      }) : false
    } else if (session) {
      const isExpired = checkExpiresToken(keycloak);

      if (!isExpired) {
        history.push('/admin/simulator')
      }
    }

    setIsLoading(false);
  }, [])

  return (
    isLoading ? <Loader /> : (
      <LoginContainer id="login-page">
        <LoginColumn>
          <LoginOverlay>
            <LoginLogo src={logo} alt="Logo Excel Credit" />
            <LoginText>
              <H4 color={colors.bgPrimary}>
                <LoginhighlightedText>Bienvenido</LoginhighlightedText> a la plataforma que apoya y agiliza el proceso de crédito digital ExcelCredit
              </H4>
              <LoginButton onClick={() => keycloak.login()} id="login-button">
                <H6 color={colors.white} semibold>Ingresar al Portal</H6>
              </LoginButton>
            </LoginText>
            <LoginCopyright>
              <LoginCopyrightImage src={copyrightImage} width={139} alt="Copyright Excel Credit" />
              <LoginCopyrightTextLine>© ExcelCredit S.A. Todos los derechos reservados</LoginCopyrightTextLine>
            </LoginCopyright>
          </LoginOverlay>
        </LoginColumn>
        <LoginColumn>
          <LoginImage src={loginImage} />
        </LoginColumn>
      </LoginContainer>
    )
  )
}

export default LoginPage;
